import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../global.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Service } from '../../services';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { ReferredTermsComponent } from '../../referred/components/referred-terms/referred-terms.component';
import { PopupInternalreferredValidateemailComponent } from '../../referred/components/popup-internalreferred-validateemail/popup-internalreferred-validateemail.component';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-redeem',
  templateUrl: './redeem.component.html',
  styleUrls: ['./redeem.component.sass']
})
export class RedeemComponent implements OnInit {
  public tabActive = 'Mis equipos y servicios';
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public currentList;
  public selectBan;
  public type;
  public token: string = sessionStorage.getItem("token");
  public porcentajeDisponible = false;
  public acc;
  public currentSuscriber;
  public objItemsReferr = [];
  public countProcentageAsReferer = 0;
  public accountName = '';
  public TotalReferer = 0;
  public CountRedeems = 0;
  public TotalRedeem=0;
  public TotalPending = 0;
  public disponibleInContent = false;
  public IdCuponReferred = null;
  public countDisponible=0;
  public porcentajeAbsoluto=false;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, private loadingScreenService: LoadingScreenService, public global: GlobalService, private formBuilder: FormBuilder, private services: Service, public dialog: MatDialog) {
    this.AngularFireAnalytics.setCurrentScreen("Redimir");
    this.AngularFireAnalytics.logEvent("Redimir-Screenview");
  }

  ngOnInit() {
    this.accountName = sessionStorage.getItem("name");
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.currentSuscriber = atob(sessionStorage.getItem("referredtSubscriber"));
    this.getCreditsByAccount();
  }
  initializeData() { }
  getCreditsByAccount() {
    this.loadingScreenService.startLoading();
    this.services.getReferrals(this.token, this.selectBan).subscribe(data => {
      if (data.hasError == false) {
        this.services.getReferrAccountsAllStatus(this.token, 1, this.selectBan, this.currentSuscriber).subscribe(data1 => {
          if (data1.hasError == false) {
            this.loadingScreenService.stopLoading();
            this.TotalRedeem = data.CreditItems[0].TotalRedeem;
            this.CountRedeems=data.CreditItems[0].CountRedeems;
            this.TotalReferer = data.CreditItems[0].TotalReferer;
            this.TotalPending = data.CreditItems[0].CountPending;
            this.countDisponible = data.CreditAsReferer.discount;
            this.objItemsReferr = data1.objItems;
            //this.objItemsReferr = [{  discountType: "$",discountMember: "45", ReferAccountName: "Juan", validFromDate: "03/06/2019", validUntilDate: "03/06/2019", cuponStatus: "disponible" }, { discountType: "$", discountMember: "50", ReferAccountName: "David", validFromDate: "03/06/2019", validUntilDate: "03/06/2019",cuponStatus: "disponible" }, { discountType: "$", discountMember: "10", ReferAccountName: "Ayala", validFromDate: "03/06/2019", validUntilDate: "03/06/2019", cuponStatus: "Redimido" }]
            for (let i = 0; i < this.objItemsReferr.length; i++) {
              if(this.objItemsReferr[i].discountType=="%"){
                this.porcentajeAbsoluto=true
              }
              if(this.objItemsReferr[i].cuponStatus.toString().toLowerCase()=="disponible"){
                if(this.objItemsReferr[i].discountType=="$"){
                  this.countDisponible+=parseInt(this.objItemsReferr[i].discountMember);

                }
                else if(this.objItemsReferr[i].discountType=="%"){
                  this.porcentajeDisponible=true
                }
              }
            }
          }
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDisplay);
          }
        });
      } else {
        this.loadingScreenService.stopLoading();
      }
    });
  }
}
